// extracted by mini-css-extract-plugin
export var hidden = "_pf-1";
export var visible = "_pf-0";